import { TableColumn } from "react-data-table-component";
import { IConfig, IRatingAndFeedback } from "src/services/types";
import { Star } from "src/components/Common/Star";

export const ColumnsUsersRatingAndFeedback: (
    config: IConfig,
) => TableColumn<IRatingAndFeedback>[] = 
(config, ) => {
      
    return (
[
    { 
      name: "N°",
      width: "80px",
      center: true,
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
      name: "USER",
      width: "230px",
      cell: function OrderItems(item) {
        return (
          <div onClick={() => {}}>
            <div className="d-flex align-items-center">
              {item?.user?.firstName} {item?.user?.lastName}
            </div>
            <small className="text-secondary">
              Rating Created at: {item?.created_at}
            </small>
          </div>
        );
      }
    },
    {
      name: "EMAIL",
      width: "170px",
      cell: function OrderItems(item) {
        return (
          <div className="" style={{fontSize: '12px'}}>
            {item?.user?.email}
          </div>
        );
      }
    },
    {
      name: "RATING",
      width: "170px",
      cell: function OrderItems(item) {
        return (
          <div className="d-flex align-items-center">
            {
              Array.from({ length: 5 }, (_, index) => (
                <Star
                  key={index}
                  size={24}
                  fillColor={index < (item?.rating || 0) ? "#FFD700" : "transparent"}
                  borderColor="#FFD700"
                  className="me-1"
                />
              ))
            }
          </div>
        );
      }
    },
    {
      name: "COMMENT",
      width: "270px",
      // center: true,
      cell: function OrderItems(item) {
        return (
          <p style={{fontSize: '13px'}}>{item?.comment}</p>
        );
      },
    },
    {
      name: "RECOMMENDATIONS",
      width: "280px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <p style={{fontSize: '13px'}}>{item?.recommendations}</p>
        );
      },
    },
  ]
)}